import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import { ContainerFlex } from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM156,
    ContenidoM156,
    ZonaTrabajoM156,
    ComparacionM156,
    RectasM156,
    FilaRectaM156,
    BottomM156
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 5;

const MAX_PARTES = 12;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222222';

const PINTADO_A = '#F2A541';
const PINTADO_B = '#7EC8E3';


const miniInstrucciones =
    'Representá las dos fracciones en las rectas y comparalas usando <, = o >.';


// ============================================================================
// PARES
// ============================================================================

const PARES = [

    {
        a: [1, 4],
        b: [1, 2]
    },

    {
        a: [1, 2],
        b: [2, 4]
    },

    {
        a: [2, 3],
        b: [1, 2]
    },

    {
        a: [3, 4],
        b: [6, 8]
    },

    {
        a: [3, 8],
        b: [1, 2]
    },

    {
        a: [1, 3],
        b: [2, 6]
    },

    {
        a: [3, 4],
        b: [2, 3]
    },

    {
        a: [1, 2],
        b: [3, 6]
    },

    {
        a: [2, 5],
        b: [1, 3]
    },

    {
        a: [2, 3],
        b: [4, 6]
    },

    {
        a: [5, 6],
        b: [3, 4]
    },

    {
        a: [1, 4],
        b: [2, 8]
    },

    {
        a: [1, 2],
        b: [4, 8]
    },

    {
        a: [3, 5],
        b: [3, 4]
    },

    {
        a: [4, 4],
        b: [2, 2]
    },

    {
        a: [3, 2],
        b: [5, 4]
    },

    {
        a: [6, 4],
        b: [3, 2]
    },

    {
        a: [5, 3],
        b: [7, 4]
    },

    {
        a: [6, 2],
        b: [2, 4]
    }

];


// ============================================================================
// AUXILIARES
// ============================================================================

const range = (
    cantidad
) => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const cursor = (
    activo
) => ({
    cursor:
        activo
            ? 'pointer'
            : 'default'
});


const mezclar = (
    array
) => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i + 1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


const compararPar = (
    par
) => {

    return Math.sign(
        par.a[0] *
        par.b[1] -
        par.b[0] *
        par.a[1]
    );
};


// ============================================================================
// SELECCIONAR 3 PARES
//
// 1 menor
// 1 equivalente
// 1 mayor
// ============================================================================

const seleccionarPares = () => {

    const menores =
        mezclar(
            PARES.filter(
                par =>
                    compararPar(
                        par
                    ) < 0
            )
        );


    const iguales =
        mezclar(
            PARES.filter(
                par =>
                    compararPar(
                        par
                    ) === 0
            )
        );


    const mayores =
        mezclar(
            PARES.filter(
                par =>
                    compararPar(
                        par
                    ) > 0
            )
        );


    // ================================================================
    // GARANTIZAMOS:
    // 1 menor
    // 1 equivalente
    // 1 mayor
    // ================================================================

    const seleccion = [

        menores[0],

        iguales[0],

        mayores[0]

    ];


    // ================================================================
    // EVITAMOS REPETIDOS
    // ================================================================

    const usados =
        new Set(
            seleccion.map(
                par =>
                    `${par.a[0]}/${par.a[1]}-${par.b[0]}/${par.b[1]}`
            )
        );


    // ================================================================
    // COMPLETAMOS HASTA 5 CON PARES ALEATORIOS
    // ================================================================

    const restantes =
        mezclar(
            PARES.filter(
                par => {

                    const clave =
                        `${par.a[0]}/${par.a[1]}-${par.b[0]}/${par.b[1]}`;


                    return !usados.has(
                        clave
                    );
                }
            )
        );


    while (
        seleccion.length <
        CANTIDAD_EJERCICIOS &&
        restantes.length >
        0
    ) {

        seleccion.push(
            restantes.shift()
        );
    }


    return mezclar(
        seleccion
    );
};


// ============================================================================
// FRACCIÓN
// ============================================================================

const Fraccion = ({
    num,
    den,
    size = 64,
    color = INK
}) => {

    return (

        <span
            style={{
                display:
                    'inline-flex',

                flexDirection:
                    'column',

                alignItems:
                    'center',

                fontFamily:
                    'Nunito',

                fontWeight:
                    800,

                color,

                lineHeight:
                    1
            }}
        >

            <span
                style={{
                    fontSize:
                        size
                }}
            >
                {num}
            </span>


            <span
                style={{
                    width:
                        size *
                        0.9,

                    height:
                        Math.max(
                            3,
                            size /
                            14
                        ),

                    background:
                        color,

                    borderRadius:
                        2,

                    margin:
                        `${size * 0.08}px 0`
                }}
            />


            <span
                style={{
                    fontSize:
                        size
                }}
            >
                {den}
            </span>

        </span>
    );
};


// ============================================================================
// BOTONES
// ============================================================================

const boton = {

    fontFamily:
        'Nunito',

    fontSize:
        16,

    fontWeight:
        600,

    padding:
        '6px 14px',

    borderRadius:
        11,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


const botonPequeno = {

    ...boton,

    padding:
        '2px 11px',

    fontSize:
        20,

    lineHeight:
        1
};


const botonSigno = {

    ...boton,

    width:
        54,

    height:
        54,

    padding:
        0,

    fontSize:
        30,

    fontWeight:
        800
};


// ============================================================================
// RECTA VACÍA
// ============================================================================

const rectaVacia = () => ({

    B:
        0,

    p:
        1,

    pint:
        [],

    mark:
        null
});


// ============================================================================
// ESTADO INICIAL
// ============================================================================

const estadoInicial = () => ({

    etapa:
        0,

    hecho:
        false,

    ra:
        rectaVacia(),

    rb:
        rectaVacia(),

    signo:
        null
});


// ============================================================================
// RECTA
// ============================================================================

const VW = 900;
const X0 = 60;
const Y = 120;
const VH = 190;


const Recta = ({
    limite,
    recta,
    color,
    onTocarParte,
    onClic,
    activo,
    guias,
    etiqueta
}) => {

    const UNIT =
        (
            VW -
            2 *
            X0
        ) /
        limite;


    const toX = (
        valor
    ) =>

        X0 +
        valor *
        UNIT;


    const TY =
        Y -
        62;

    const TH =
        44;


    const clic = (
        e
    ) => {

        if (
            !activo
        ) {

            return;
        }


        const svg =
            e.currentTarget
                .ownerSVGElement;


        if (
            !svg
        ) {

            return;
        }


        const pt =
            svg.createSVGPoint();


        pt.x =
            e.clientX;

        pt.y =
            e.clientY;


        const matrix =
            svg.getScreenCTM();


        if (
            !matrix
        ) {

            return;
        }


        const local =
            pt.matrixTransform(
                matrix.inverse()
            );


        onClic(

            Math.max(
                0,
                Math.min(
                    limite,
                    (
                        local.x -
                        X0
                    ) /
                    UNIT
                )
            ),

            UNIT
        );
    };


    return (

        <svg
            viewBox={
                `0 0 ${VW} ${VH}`
            }
            style={{
                width:
                    '100%',

                height:
                    'auto',

                display:
                    'block',

                userSelect:
                    'none'
            }}
            role="img"
            aria-label="Recta numérica"
        >

            {/* ============================================================= */}
            {/* GUÍAS PUNTEADAS                                               */}
            {/* ============================================================= */}

            {
                guias
                    .filter(
                        guia =>
                            guia !== null &&
                            guia !== undefined
                    )
                    .map(
                        (
                            guia,
                            index
                        ) => (

                            <line
                                key={
                                    index
                                }
                                x1={
                                    toX(
                                        guia
                                    )
                                }
                                y1={
                                    10
                                }
                                x2={
                                    toX(
                                        guia
                                    )
                                }
                                y2={
                                    VH -
                                    10
                                }
                                stroke="#888888"
                                strokeWidth={
                                    2
                                }
                                strokeDasharray="6 6"
                                pointerEvents="none"
                            />
                        )
                    )
            }


            {/* ============================================================= */}
            {/* LÍNEA                                                         */}
            {/* ============================================================= */}

            <line
                x1={
                    toX(
                        0
                    ) -
                    40
                }
                y1={
                    Y
                }
                x2={
                    toX(
                        limite
                    ) +
                    40
                }
                y2={
                    Y
                }
                stroke={
                    INK
                }
                strokeWidth={
                    3
                }
            />


            <polygon
                points={
                    `${toX(0) - 52},${Y} ${toX(0) - 38},${Y - 8} ${toX(0) - 38},${Y + 8}`
                }
                fill={
                    INK
                }
            />


            <polygon
                points={
                    `${toX(limite) + 52},${Y} ${toX(limite) + 38},${Y - 8} ${toX(limite) + 38},${Y + 8}`
                }
                fill={
                    INK
                }
            />


            {/* ============================================================= */}
            {/* ENTEROS                                                       */}
            {/* ============================================================= */}

            {
                range(
                    limite +
                    1
                )
                    .map(
                        numero => (

                            <g
                                key={
                                    numero
                                }
                            >

                                <line
                                    x1={
                                        toX(
                                            numero
                                        )
                                    }
                                    y1={
                                        Y -
                                        12
                                    }
                                    x2={
                                        toX(
                                            numero
                                        )
                                    }
                                    y2={
                                        Y +
                                        12
                                    }
                                    stroke={
                                        INK
                                    }
                                    strokeWidth={
                                        3
                                    }
                                />


                                <text
                                    x={
                                        toX(
                                            numero
                                        )
                                    }
                                    y={
                                        Y +
                                        38
                                    }
                                    textAnchor="middle"
                                    fontSize="22"
                                    fontWeight="600"
                                    fill={
                                        INK
                                    }
                                >
                                    {
                                        numero
                                    }
                                </text>

                            </g>
                        )
                    )
            }


            {/* ============================================================= */}
            {/* ÁREA CLICKEABLE                                                */}
            {/* ============================================================= */}

            <rect
                x={
                    toX(
                        0
                    ) -
                    20
                }
                y={
                    Y -
                    14
                }
                width={
                    UNIT *
                    limite +
                    40
                }
                height={
                    56
                }
                fill="transparent"
                style={
                    cursor(
                        activo
                    )
                }
                onClick={
                    activo
                        ? clic
                        : undefined
                }
            />


            {/* ============================================================= */}
            {/* BANDEJAS                                                      */}
            {/* ============================================================= */}

            {
                range(
                    recta.B
                )
                    .map(
                        bandeja => (

                            <g
                                key={
                                    bandeja
                                }
                            >

                                {
                                    range(
                                        recta.p
                                    )
                                        .map(
                                            parte => (

                                                <rect
                                                    key={
                                                        parte
                                                    }
                                                    x={
                                                        toX(
                                                            bandeja
                                                        ) +
                                                        (
                                                            parte *
                                                            UNIT
                                                        ) /
                                                        recta.p
                                                    }
                                                    y={
                                                        TY
                                                    }
                                                    width={
                                                        UNIT /
                                                        recta.p
                                                    }
                                                    height={
                                                        TH
                                                    }
                                                    fill={
                                                        recta.pint[
                                                            bandeja *
                                                            recta.p +
                                                            parte
                                                        ]

                                                            ? color
                                                            : '#F4F1EC'
                                                    }
                                                    stroke="#333333"
                                                    strokeWidth={
                                                        2
                                                    }
                                                    style={
                                                        cursor(
                                                            activo
                                                        )
                                                    }
                                                    onClick={() => {

                                                        if (
                                                            activo
                                                        ) {

                                                            onTocarParte(
                                                                bandeja,
                                                                parte
                                                            );
                                                        }
                                                    }}
                                                />
                                            )
                                        )
                                }


                                <rect
                                    x={
                                        toX(
                                            bandeja
                                        )
                                    }
                                    y={
                                        TY
                                    }
                                    width={
                                        UNIT
                                    }
                                    height={
                                        TH
                                    }
                                    fill="none"
                                    stroke="#333333"
                                    strokeWidth={
                                        3
                                    }
                                    rx={
                                        3
                                    }
                                    pointerEvents="none"
                                />

                            </g>
                        )
                    )
            }


            {/* ============================================================= */}
            {/* MARCA                                                         */}
            {/* ============================================================= */}

            {
                recta.mark !== null && (

                    <g
                        pointerEvents="none"
                    >

                        <circle
                            cx={
                                toX(
                                    recta.mark
                                )
                            }
                            cy={
                                Y
                            }
                            r={
                                10
                            }
                            fill={
                                etiqueta
                                    ? OK
                                    : MARK
                            }
                            stroke="#FFFFFF"
                            strokeWidth={
                                2
                            }
                        />


                        {
                            etiqueta && (

                                <g
                                    fill={
                                        OK
                                    }
                                    fontWeight="800"
                                    fontSize="20"
                                    textAnchor="middle"
                                >

                                    <text
                                        x={
                                            toX(
                                                recta.mark
                                            )
                                        }
                                        y={
                                            Y +
                                            32
                                        }
                                        fill="#FFFFFF"
                                        stroke="#FFFFFF"
                                        strokeWidth={
                                            8
                                        }
                                    >
                                        {
                                            etiqueta
                                        }
                                    </text>


                                    <text
                                        x={
                                            toX(
                                                recta.mark
                                            )
                                        }
                                        y={
                                            Y +
                                            32
                                        }
                                    >
                                        {
                                            etiqueta
                                        }
                                    </text>

                                </g>
                            )
                        }

                    </g>
                )
            }

        </svg>
    );
};


// ============================================================================
// CONTROLES DE RECTA
// ============================================================================

const ControlesRecta = ({
    recta,
    limite,
    onCambio,
    activo
}) => {


    const poner = () => {

        if (
            !activo ||
            recta.B >= limite
        ) {

            return;
        }


        onCambio({

            B:
                recta.B + 1,

            pint: [
                ...recta.pint,

                ...Array(
                    recta.p
                ).fill(
                    false
                )
            ]
        });
    };


    const sacar = () => {

        if (
            !activo ||
            recta.B === 0
        ) {

            return;
        }


        const nuevaCantidad =
            recta.B -
            1;


        onCambio({

            B:
                nuevaCantidad,

            pint:
                recta.pint.slice(
                    0,
                    nuevaCantidad *
                    recta.p
                )
        });
    };


    const partir = (
        partes
    ) => {

        if (
            !activo
        ) {

            return;
        }


        onCambio({

            p:
                partes,

            pint:
                Array(
                    recta.B *
                    partes
                ).fill(
                    false
                )
        });
    };


    if (
        !activo
    ) {

        return null;
    }


    return (

        <div
            className="controles-recta-m156"
        >

            <button
                type="button"
                style={{
                    ...boton,

                    opacity:
                        recta.B >=
                        limite

                            ? 0.4
                            : 1
                }}
                disabled={
                    recta.B >=
                    limite
                }
                onClick={
                    poner
                }
            >
                Poner bandeja
            </button>


            {
                recta.B > 0 && (

                    <button
                        type="button"
                        style={{
                            ...boton,

                            borderColor:
                                MARK,

                            color:
                                MARK
                        }}
                        onClick={
                            sacar
                        }
                    >
                        Sacar bandeja
                    </button>
                )
            }


            {
                recta.B > 0 && (

                    <div
                        className="partir-m156"
                    >

                        <span>
                            Partir en:
                        </span>


                        <button
                            type="button"
                            style={{
                                ...botonPequeno,

                                opacity:
                                    recta.p <=
                                    1

                                        ? 0.4
                                        : 1
                            }}
                            disabled={
                                recta.p <=
                                1
                            }
                            aria-label="Menos partes"
                            onClick={() =>
                                partir(
                                    recta.p -
                                    1
                                )
                            }
                        >
                            −
                        </button>


                        <span
                            className="numero-partes-m156"
                        >
                            {
                                recta.p
                            }
                        </span>


                        <button
                            type="button"
                            style={{
                                ...botonPequeno,

                                opacity:
                                    recta.p >=
                                    MAX_PARTES

                                        ? 0.4
                                        : 1
                            }}
                            disabled={
                                recta.p >=
                                MAX_PARTES
                            }
                            aria-label="Más partes"
                            onClick={() =>
                                partir(
                                    recta.p +
                                    1
                                )
                            }
                        >
                            +
                        </button>

                    </div>
                )
            }

        </div>
    );
};


// ============================================================================
// M156
// ============================================================================

const M156 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // =========================================================================
    // REDUX
    // =========================================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================================
    // EJERCICIOS
    // =========================================================================

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(0);


    const [
        st,
        setSt
    ] = useState(
        estadoInicial
    );


    // =========================================================================
    // FEEDBACK
    // =========================================================================

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    // =========================================================================
    // ERRORES
    // =========================================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // =========================================================================
    // ESTÍMULOS
    // =========================================================================

    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // =========================================================================
    // PAR ACTUAL
    // =========================================================================

    const parActual =
        ejercicios.length > 0

            ? ejercicios[
                count
            ]

            : null;


    const na =
        parActual
            ? parActual.a[0]
            : 0;


    const da =
        parActual
            ? parActual.a[1]
            : 1;


    const nb =
        parActual
            ? parActual.b[0]
            : 0;


    const db =
        parActual
            ? parActual.b[1]
            : 1;


    const comparacion =
        Math.sign(
            na *
            db -
            nb *
            da
        );


    const signoCorrecto =
        comparacion < 0

            ? '<'

            : comparacion > 0

                ? '>'
                : '=';


    const limiteRecta =
        Math.ceil(
            Math.max(
                na /
                da,

                nb /
                db
            )
        ) +
        2;


    const enRectas =
        st.etapa === 0 &&
        !st.hecho &&
        !disable;


    const terminado =
        st.etapa === 1 &&
        st.hecho;


    const guias =
        st.etapa === 1

            ? [
                st.ra.mark,
                st.rb.mark
            ]

            : [];


    // =========================================================================
    // SONIDOS
    // =========================================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================================
    // ACTUALIZACIÓN GENERAL
    // =========================================================================

    const actualizar = (
        cambios
    ) => {

        setSt(
            anterior => ({

                ...anterior,

                ...(
                    typeof cambios === 'function'

                        ? cambios(
                            anterior
                        )

                        : cambios
                )
            })
        );


        setFeedback(
            null
        );
    };


    // =========================================================================
    // CAMBIAR UNA RECTA
    // =========================================================================

    const cambiarRecta = (
        clave,
        cambios
    ) => {

        setSt(
            anterior => {

                const rectaAnterior =
                    anterior[
                        clave
                    ];


                const cambiosRecta =
                    typeof cambios === 'function'

                        ? cambios(
                            rectaAnterior
                        )

                        : cambios;


                return {

                    ...anterior,

                    [
                        clave
                    ]: {

                        ...rectaAnterior,

                        ...cambiosRecta
                    }
                };
            }
        );


        setFeedback(
            null
        );
    };


    // =========================================================================
    // TOCAR PARTE
    // =========================================================================

    const tocarParte = (
        clave,
        bandeja,
        parte
    ) => {

        if (
            !enRectas
        ) {

            return;
        }


        cambiarRecta(
            clave,
            recta => {

                const posicion =
                    bandeja *
                    recta.p +
                    parte;


                return {

                    pint:
                        recta.pint.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index ===
                                posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    // =========================================================================
    // MARCAR RECTA
    // =========================================================================

    const marcar = (
        clave,
        valor,
        UNIT
    ) => {

        if (
            !enRectas
        ) {

            return;
        }


        cambiarRecta(
            clave,
            recta => {

                let marca =
                    Math.round(
                        valor *
                        1000
                    ) /
                    1000;


                if (
                    recta.B > 0 &&
                    recta.p > 1
                ) {

                    const paso =
                        Math.round(
                            valor *
                            recta.p
                        ) /
                        recta.p;


                    if (
                        Math.abs(
                            paso -
                            valor
                        ) *
                        UNIT <
                        14
                    ) {

                        marca =
                            paso;
                    }
                }


                return {

                    mark:
                        marca
                };
            }
        );
    };


    // =========================================================================
    // ERROR
    //
    // Shake + sonido + bloqueo 300 ms
    // =========================================================================

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores +
                1
        );


        setErroresItemActual(
            errores =>
                errores +
                1
        );


        setFeedback({

            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );


            setDisable(
                false
            );

        }, 300);
    };


    // =========================================================================
    // REVISAR UNA RECTA
    // =========================================================================

    const revisarRecta = (
        recta,
        numerador,
        denominador,
        cual
    ) => {

        if (
            recta.B === 0
        ) {

            return (
                `Poné bandejas en la recta de ${cual}.`
            );
        }


        const pintadas =
            recta.pint.filter(
                Boolean
            ).length;


        // Permite representaciones equivalentes.
        if (
            (
                numerador *
                recta.p
            ) %
            denominador !==
            0
        ) {

            return (
                `Recta de ${cual}: mirá el denominador. ¿En cuántas partes conviene partir cada bandeja?`
            );
        }


        if (
            pintadas *
            denominador !==
            numerador *
            recta.p
        ) {

            return (

                pintadas *
                denominador >
                numerador *
                recta.p

                    ? `Recta de ${cual}: pintaste de más.`

                    : `Recta de ${cual}: te falta pintar.`
            );
        }


        if (
            recta.mark === null
        ) {

            return (
                `Recta de ${cual}: marcá el número con un clic sobre la recta.`
            );
        }


        if (
            Math.abs(
                recta.mark -
                numerador /
                denominador
            ) >
            0.03
        ) {

            return (
                `Recta de ${cual}: el punto tiene que ir donde termina lo pintado.`
            );
        }


        return null;
    };


    // =========================================================================
    // CORRECTO
    //
    // Zoom + sonido + 300ms + avance automático
    // =========================================================================

    const etapaCorrecta = (
        texto
    ) => {

        const etapaActual =
            st.etapa;


        setDisable(
            true
        );


        setIsCorrect(
            true
        );


        setSt(
            anterior => ({

                ...anterior,

                hecho:
                    true
            })
        );


        setFeedback({

            ok:
                true,

            text:
                texto
        });


        GoodWork();


        setTimeout(() => {


            setIsCorrect(
                false
            );


            // =================================================================
            // TERMINÓ LAS RECTAS
            // PASA SOLO A COMPARAR
            // =================================================================

            if (
                etapaActual === 0
            ) {

                setSt(
                    anterior => ({

                        ...anterior,

                        etapa:
                            1,

                        hecho:
                            false,

                        signo:
                            null
                    })
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ EL PAR COMPLETO
            // =================================================================

            const textoPar =
                `${na}/${da}${signoCorrecto}${nb}/${db}`;


            const nuevaLista = [

                ...respuestasOrden,

                textoPar

            ];


            const nuevosErrores = [

                ...erroresOrden,

                erroresItemActual

            ];


            setRespuestasOrden(
                nuevaLista
            );


            setErroresOrden(
                nuevosErrores
            );


            // =================================================================
            // SIGUIENTE PAR
            // =================================================================

            if (
                count <
                ejercicios.length -
                1
            ) {

                setCount(
                    anterior =>
                        anterior +
                        1
                );


                setSt(
                    estadoInicial()
                );


                setErroresItemActual(
                    0
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // FIN M156
            // =================================================================

            setFeedback(
                null
            );


            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 50);


        }, 300);
    };


    // =========================================================================
    // COMPROBAR
    // =========================================================================

    const comprobar = () => {

        if (
            disable ||
            st.hecho ||
            !parActual
        ) {

            return;
        }


        // =====================================================================
        // ETAPA 1
        // CONSTRUIR LAS DOS RECTAS
        // =====================================================================

        if (
            st.etapa === 0
        ) {

            const errorArriba =
                revisarRecta(
                    st.ra,
                    na,
                    da,
                    'arriba'
                );


            if (
                errorArriba
            ) {

                marcarError(
                    errorArriba
                );

                return;
            }


            const errorAbajo =
                revisarRecta(
                    st.rb,
                    nb,
                    db,
                    'abajo'
                );


            if (
                errorAbajo
            ) {

                marcarError(
                    errorAbajo
                );

                return;
            }


            etapaCorrecta(
                '¡Muy bien! Ahora compará las dos fracciones.'
            );


            return;
        }


        // =====================================================================
        // ETAPA 2
        // COMPARAR
        // =====================================================================

        if (
            !st.signo
        ) {

            marcarError(
                'Elegí un signo: <, = o >.'
            );

            return;
        }


        if (
            st.signo ===
            signoCorrecto
        ) {

            if (
                comparacion === 0
            ) {

                etapaCorrecta(
                    `¡Muy bien! ${na}/${da} y ${nb}/${db} son equivalentes.`
                );


                return;
            }


            etapaCorrecta(

                `¡Muy bien! ${na}/${da} es ${
                    comparacion < 0
                        ? 'menor'
                        : 'mayor'
                } que ${nb}/${db}.`
            );


            return;
        }


        marcarError(
            'Mirá las líneas punteadas. ¿Cuál llega más lejos? ¿O llegan al mismo lugar?'
        );
    };


    // =========================================================================
    // PLAY
    //
    // SOLO COMPRUEBA
    // =========================================================================

    const verificar = (
        e
    ) => {

        e.preventDefault();


        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        comprobar();
    };


    // =========================================================================
    // INICIALIZAR
    // =========================================================================

    useEffect(() => {

        const seleccion =
            seleccionarPares();


        setEjercicios(
            seleccion
        );


        setCount(
            0
        );


        setSt(
            estadoInicial()
        );


        dispatch(
            setearEjercicioAction(
                'M156'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M156',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={
                        true
                    }
                    carrito={
                        true
                    }
                    minMay={
                        false
                    }
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !parActual
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM156>


            <HeaderEjercicios
                estrellas={
                    true
                }
                carrito={
                    true
                }
                minMay={
                    false
                }
            />


            <ContenidoM156>


                <ContainerFlex
                    height="100%"
                    width="100%"
                    display="flex"
                    direction="column"
                    justify="center"
                    align="center"
                    isCorrect={
                        isCorrect
                    }
                    isIncorrect={
                        isIncorrect
                    }
                    $mantengoMay={
                        true
                    }
                >


                    <ZonaTrabajoM156>


                        {/* ================================================= */}
                        {/* CONSIGNA                                         */}
                        {/* ================================================= */}

                        <p
                            className="consigna-m156"
                        >
                            {
                                st.etapa === 0

                                    ? 'Representá cada fracción y marcala en su recta.'

                                    : '¿Cuál es mayor? Elegí <, = o >.'
                            }
                        </p>


                        {/* ================================================= */}
                        {/* COMPARACIÓN                                      */}
                        {/* ================================================= */}

                        {
                            st.etapa === 1 && (

                                <ComparacionM156>


                                    <div
                                        className="comparacion-simbolica-m156"
                                    >

                                        <Fraccion
                                            num={
                                                na
                                            }
                                            den={
                                                da
                                            }
                                            size={
                                                58
                                            }
                                        />


                                        <div
                                            className={
                                                terminado
                                                    ? 'signo-m156 correcto'
                                                    : 'signo-m156'
                                            }
                                        >
                                            {
                                                st.signo ||
                                                '?'
                                            }
                                        </div>


                                        <Fraccion
                                            num={
                                                nb
                                            }
                                            den={
                                                db
                                            }
                                            size={
                                                58
                                            }
                                        />

                                    </div>


                                    {
                                        !st.hecho && (

                                            <div
                                                className="botones-signo-m156"
                                            >

                                                {
                                                    [
                                                        '<',
                                                        '=',
                                                        '>'
                                                    ]
                                                        .map(
                                                            signo => (

                                                                <button
                                                                    key={
                                                                        signo
                                                                    }
                                                                    type="button"
                                                                    style={{
                                                                        ...botonSigno,

                                                                        background:
                                                                            st.signo === signo

                                                                                ? '#E6F4F4'
                                                                                : '#FFFFFF',

                                                                        opacity:
                                                                            disable
                                                                                ? 0.5
                                                                                : 1
                                                                    }}
                                                                    disabled={
                                                                        disable
                                                                    }
                                                                    onClick={() =>
                                                                        actualizar({
                                                                            signo
                                                                        })
                                                                    }
                                                                >
                                                                    {
                                                                        signo
                                                                    }
                                                                </button>
                                                            )
                                                        )
                                                }

                                            </div>
                                        )
                                    }


                                </ComparacionM156>
                            )
                        }


                        {/* ================================================= */}
                        {/* RECTAS                                           */}
                        {/* ================================================= */}

                        <RectasM156>


                            {/* ============================================= */}
                            {/* RECTA A                                       */}
                            {/* ============================================= */}

                            <FilaRectaM156>


                                <div
                                    className="etiqueta-fraccion-m156 arriba"
                                >

                                    <Fraccion
                                        num={
                                            na
                                        }
                                        den={
                                            da
                                        }
                                        size={
                                            23
                                        }
                                    />

                                </div>


                                <div
                                    className="recta-m156"
                                >

                                    <Recta
                                        limite={
                                            limiteRecta
                                        }
                                        recta={
                                            st.ra
                                        }
                                        color={
                                            PINTADO_A
                                        }
                                        onTocarParte={
                                            (
                                                bandeja,
                                                parte
                                            ) =>
                                                tocarParte(
                                                    'ra',
                                                    bandeja,
                                                    parte
                                                )
                                        }
                                        onClic={
                                            (
                                                valor,
                                                unit
                                            ) =>
                                                marcar(
                                                    'ra',
                                                    valor,
                                                    unit
                                                )
                                        }
                                        activo={
                                            enRectas
                                        }
                                        guias={
                                            guias
                                        }
                                        etiqueta={
                                            st.etapa === 1

                                                ? `${na}/${da}`

                                                : null
                                        }
                                    />


                                    <ControlesRecta
                                        recta={
                                            st.ra
                                        }
                                        limite={
                                            limiteRecta
                                        }
                                        activo={
                                            enRectas
                                        }
                                        onCambio={
                                            cambios =>
                                                cambiarRecta(
                                                    'ra',
                                                    cambios
                                                )
                                        }
                                    />

                                </div>


                            </FilaRectaM156>


                            {/* ============================================= */}
                            {/* RECTA B                                       */}
                            {/* ============================================= */}

                            <FilaRectaM156>


                                <div
                                    className="etiqueta-fraccion-m156 abajo"
                                >

                                    <Fraccion
                                        num={
                                            nb
                                        }
                                        den={
                                            db
                                        }
                                        size={
                                            23
                                        }
                                    />

                                </div>


                                <div
                                    className="recta-m156"
                                >

                                    <Recta
                                        limite={
                                            limiteRecta
                                        }
                                        recta={
                                            st.rb
                                        }
                                        color={
                                            PINTADO_B
                                        }
                                        onTocarParte={
                                            (
                                                bandeja,
                                                parte
                                            ) =>
                                                tocarParte(
                                                    'rb',
                                                    bandeja,
                                                    parte
                                                )
                                        }
                                        onClic={
                                            (
                                                valor,
                                                unit
                                            ) =>
                                                marcar(
                                                    'rb',
                                                    valor,
                                                    unit
                                                )
                                        }
                                        activo={
                                            enRectas
                                        }
                                        guias={
                                            guias
                                        }
                                        etiqueta={
                                            st.etapa === 1

                                                ? `${nb}/${db}`

                                                : null
                                        }
                                    />


                                    <ControlesRecta
                                        recta={
                                            st.rb
                                        }
                                        limite={
                                            limiteRecta
                                        }
                                        activo={
                                            enRectas
                                        }
                                        onCambio={
                                            cambios =>
                                                cambiarRecta(
                                                    'rb',
                                                    cambios
                                                )
                                        }
                                    />

                                </div>


                            </FilaRectaM156>


                        </RectasM156>


                        {/* ================================================= */}
                        {/* FEEDBACK                                         */}
                        {/* ================================================= */}

                        <p
                            className={
                                feedback

                                    ? feedback.ok

                                        ? 'feedback-m156 ok'
                                        : 'feedback-m156 error'

                                    : 'feedback-m156'
                            }
                        >
                            {
                                feedback
                                    ? feedback.text
                                    : '.'
                            }
                        </p>


                    </ZonaTrabajoM156>


                </ContainerFlex>


            </ContenidoM156>


            {/* ============================================================= */}
            {/* BOTTOM                                                        */}
            {/* ============================================================= */}

            <BottomM156>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        st.hecho
                    }
                    onClick={
                        verificar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM156>


        </PantallaM156>
    );
};


export default M156;